import {
  USE_BILLING_FOR_SHIPPING_TOGGLE,
  NOTIFY_ERROR,
  NOTIFY_COMPLETE_CHECKOUT_ERROR,
  PLACE_ORDER_ASYNC,
  DISMISS_MESSAGE,
  SELECT_PAYMENT_OPTION,
  BRAINTREEE_PAYMENT_DATA_UPDATE,
  PURCHASE_ORDER_PAYMENT_DATA_UPDATE
} from '../actions'

import {
  addToList,
  replaceInListById
} from './listUtility'

import {
  ERROR_USER_ALERT, 
  UNKNOWN_USER_ALERT
} from '../models'

export function useShippingForBilling(state = true, action) {
  switch (action.type) {
    case USE_BILLING_FOR_SHIPPING_TOGGLE:
      return !state;
  }
  return state;
}

export function PhoneNumber(state = 'tel:+14144254069', action) {
  return state;
}

export function PhoneText(state = '(414) 425-4069', action) {
  return state;
}

const mapActionTypeToUserAlertType = (actionType) => {
  switch(actionType) {
    case NOTIFY_ERROR:
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return ERROR_USER_ALERT;
  }
  return UNKNOWN_USER_ALERT;
}

export function messages(state = [], action) {
  switch (action.type) {
    case NOTIFY_ERROR:
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return addToList(
        state,
        {
          type: mapActionTypeToUserAlertType(action.type),
          text: action.message,
          id: action.messageId
        });
    case DISMISS_MESSAGE:
      return replaceInListById(
        state,
        Object.assign({}, state.filter(m => m.Id === action.messageId)[0], { dismissed: true }))
  }
  return state;
}

export function completeCheckoutButtonText(state = '', action) {
  return state;
}

export function isPlaceOrderPending(state = false, action) {
  switch (action.type) {
    case PLACE_ORDER_ASYNC:
      return true;
    case NOTIFY_COMPLETE_CHECKOUT_ERROR:
      return false;
  }
  return state;
}

const formatPaypalPayloadDetailsForSummary = (det) => {
  if (det) {
    if (typeof (det.firstName) !== 'undefined' && typeof (det.lastName) !== 'undefined') {
      return `${det.firstName.length > 0 ? det.firstName + " " : ""} ${det.lastName.length > 0 ? det.lastName + " " : ""
        }(${
        det.email})`;
    } else if (typeof (det.email) !== 'undefined') {
      return det.email;
    }
  }
  return "account";
}

const updateBraintreeLabel = (payload) => {
  if (!payload) {
    return "Pending";
  } else {
    if (payload.type === "PayPalAccount") {
      return `Paypal: ${formatPaypalPayloadDetailsForSummary(payload.details)}`;
    } else if (payload.type === "CreditCard") {
      return `Card: ${payload.description}`
    } else {
      return "Unknown payment method";
    }
    
  }
}

export function selectedPaymentLabel(state = "", action) {
  switch (action.type) {
    case SELECT_PAYMENT_OPTION:
      return action.displayName || '';
    case BRAINTREEE_PAYMENT_DATA_UPDATE:
      return updateBraintreeLabel(action.payload);
    case PURCHASE_ORDER_PAYMENT_DATA_UPDATE:
      return `Purchase Order ${((action.number.length > 0) ? " #: " : "")}${action.number}`;
  }
  return state;
}